import {
  B2bCustomer,
  ByLinePattern,
  PageInfo,
  PatternSortableFieldsEnum,
  SecondaryUser,
  SortDirectionEnum,
} from 'types/graphql';
import { QUERY_scheduleByLinePatternsSummary } from 'queries';
import { createApolloClient } from 'providers/ApolloProvider';

export const LINE_SCHEDULE_DRAG_AND_DROP_ITEM = 'line-schedule-dnd-item';
export const LINE_SCHEDULE_SCROLL_CONTAINER_ID = 'lineScheduleScrollContainer';

export const getRowId = (index: number) => `row-${index}`;

const PAGE_SIZE = 20;

const client = createApolloClient({});

const sortVariables = {
  sort: [
    {
      field: PatternSortableFieldsEnum.created_at,
      direction: SortDirectionEnum.desc,
    },
  ],
};

type FetchPatternsResult = {
  patterns: ByLinePattern[];
  pageInfo: Pick<PageInfo, 'endCursor' | 'hasNextPage'> | null;
};

export async function fetchPatterns(
  afterCursor?: string,
  searchQuery?: string,
): Promise<FetchPatternsResult> {
  const res = await client.query({
    query: QUERY_scheduleByLinePatternsSummary,
    variables: {
      ...sortVariables,
      first: PAGE_SIZE,
      ...(afterCursor ? { after: afterCursor } : {}),
      ...(searchQuery?.trim() ? { filter: { withName: searchQuery.trim() } } : {}),
    },
    fetchPolicy: 'network-only',
  });

  const data = res.data?.me as B2bCustomer | SecondaryUser;
  const patterns = data?.byLinePatterns?.nodes ?? [];
  const resPageInfo = data?.byLinePatterns?.pageInfo;

  return {
    patterns,
    pageInfo: resPageInfo
      ? { endCursor: resPageInfo.endCursor, hasNextPage: resPageInfo.hasNextPage }
      : null,
  };
}
